import { Main } from '@shared/models/Main.model';

export class Permission extends Main {
  id: number = -1;
  name: string = '';
  guard_name: string = '';
  [key: string]: any;
}
